import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function CtaBand() {
  return <section id="cta" className="bg-signal py-20 text-white md:py-32" data-id="element-16">
      <div className="mx-auto max-w-[1200px] px-5 md:px-8" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-start gap-8 lg:flex-row lg:items-end lg:justify-between" data-id="element-18">
          <h2 className="max-w-3xl font-display text-5xl font-semibold leading-[0.95] tracking-tight md:text-7xl lg:text-8xl" data-id="element-19">
            Read every signal. Miss nothing.
          </h2>
          <div className="flex flex-shrink-0 flex-col gap-3 sm:flex-row" data-id="element-20">
            <a href="#top" className="group inline-flex items-center justify-center gap-2 rounded-full bg-white px-7 py-4 text-base font-semibold text-ink transition-colors hover:bg-ink hover:text-white" data-id="element-21">
              Start free
              <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-22" />
            </a>
            <a href="#top" className="inline-flex items-center justify-center rounded-full border border-white/50 px-7 py-4 text-base font-semibold text-white transition-colors hover:bg-white/10" data-id="element-23">
              Book a demo
            </a>
          </div>
        </motion.div>
        <p className="mt-8 text-white/70" data-id="element-24">
          Free forever plan · No credit card · Live in under an hour
        </p>
      </div>
    </section>;
}